import * as React from 'react';
import React__default, { useState, useContext, useEffect, forwardRef, useMemo, useId } from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import './index.external.css';

function ownKeys$2(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2$2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) {
      _defineProperty$2(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive$2(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey$2(t) {
  var i = _toPrimitive$2(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _defineProperty$2(obj, key, value) {
  key = _toPropertyKey$2(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties$2(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$2(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var rightLinkArrowIcon = /*#__PURE__*/React__default.createElement("svg", {
  height: "16",
  width: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "m10.53 2.47 5 5a.75.75 0 0 1 .01 1.04l-5 5-.35-.35a1 1 0 0 1 0-1.42l3-3H5a1 1 0 0 1-1-1v-.5h9.18l-3-3a1 1 0 0 1 0-1.42l.35-.35ZM2 7.25a1 1 0 0 1 1 1v.5H1a1 1 0 0 1-1-1v-.5Z",
  fill: "currentColor",
  fillRule: "evenodd"
}));

function ownKeys$1(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2$1(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) {
      _defineProperty$1(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive$1(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey$1(t) {
  var i = _toPrimitive$1(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _defineProperty$1(obj, key, value) {
  key = _toPropertyKey$1(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var head$1 = {
  exports: {}
};
var _interop_require_default$1 = {};
_interop_require_default$1._ = _interop_require_default$1._interop_require_default = _interop_require_default;
function _interop_require_default(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var _interop_require_wildcard$1 = {};
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function (nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
_interop_require_wildcard$1._ = _interop_require_wildcard$1._interop_require_wildcard = _interop_require_wildcard;
function _interop_require_wildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) return obj;
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
    default: obj
  };
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) return cache.get(obj);
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);else newObj[key] = obj[key];
    }
  }
  newObj.default = obj;
  if (cache) cache.set(obj, newObj);
  return newObj;
}
var sideEffect = {};
var hasRequiredSideEffect;
function requireSideEffect() {
  if (hasRequiredSideEffect) return sideEffect;
  hasRequiredSideEffect = 1;
  (function (exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    Object.defineProperty(exports, "default", {
      enumerable: true,
      get: function () {
        return SideEffect;
      }
    });
    const _interop_require_wildcard = _interop_require_wildcard$1;
    const _react = /*#__PURE__*/_interop_require_wildcard._(React__default);
    const isServer = typeof window === "undefined";
    const useClientOnlyLayoutEffect = isServer ? () => {} : _react.useLayoutEffect;
    const useClientOnlyEffect = isServer ? () => {} : _react.useEffect;
    function SideEffect(props) {
      const {
        headManager,
        reduceComponentsToState
      } = props;
      function emitChange() {
        if (headManager && headManager.mountedInstances) {
          const headElements = _react.Children.toArray(Array.from(headManager.mountedInstances).filter(Boolean));
          headManager.updateHead(reduceComponentsToState(headElements, props));
        }
      }
      if (isServer) {
        var _headManager_mountedInstances;
        headManager == null ? void 0 : (_headManager_mountedInstances = headManager.mountedInstances) == null ? void 0 : _headManager_mountedInstances.add(props.children);
        emitChange();
      }
      useClientOnlyLayoutEffect(() => {
        var _headManager_mountedInstances;
        headManager == null ? void 0 : (_headManager_mountedInstances = headManager.mountedInstances) == null ? void 0 : _headManager_mountedInstances.add(props.children);
        return () => {
          var _headManager_mountedInstances;
          headManager == null ? void 0 : (_headManager_mountedInstances = headManager.mountedInstances) == null ? void 0 : _headManager_mountedInstances.delete(props.children);
        };
      });
      // We need to call `updateHead` method whenever the `SideEffect` is trigger in all
      // life-cycles: mount, update, unmount. However, if there are multiple `SideEffect`s
      // being rendered, we only trigger the method from the last one.
      // This is ensured by keeping the last unflushed `updateHead` in the `_pendingUpdate`
      // singleton in the layout effect pass, and actually trigger it in the effect pass.
      useClientOnlyLayoutEffect(() => {
        if (headManager) {
          headManager._pendingUpdate = emitChange;
        }
        return () => {
          if (headManager) {
            headManager._pendingUpdate = emitChange;
          }
        };
      });
      useClientOnlyEffect(() => {
        if (headManager && headManager._pendingUpdate) {
          headManager._pendingUpdate();
          headManager._pendingUpdate = null;
        }
        return () => {
          if (headManager && headManager._pendingUpdate) {
            headManager._pendingUpdate();
            headManager._pendingUpdate = null;
          }
        };
      });
      return null;
    }
  })(sideEffect);
  return sideEffect;
}
var ampContext = {};
var hasRequiredAmpContext;
function requireAmpContext() {
  if (hasRequiredAmpContext) return ampContext;
  hasRequiredAmpContext = 1;
  (function (exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    Object.defineProperty(exports, "AmpStateContext", {
      enumerable: true,
      get: function () {
        return AmpStateContext;
      }
    });
    const _interop_require_default = _interop_require_default$1;
    const _react = /*#__PURE__*/_interop_require_default._(React__default);
    const AmpStateContext = _react.default.createContext({});
    if (process.env.NODE_ENV !== "production") {
      AmpStateContext.displayName = "AmpStateContext";
    }
  })(ampContext);
  return ampContext;
}
var headManagerContext = {};
var hasRequiredHeadManagerContext;
function requireHeadManagerContext() {
  if (hasRequiredHeadManagerContext) return headManagerContext;
  hasRequiredHeadManagerContext = 1;
  (function (exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    Object.defineProperty(exports, "HeadManagerContext", {
      enumerable: true,
      get: function () {
        return HeadManagerContext;
      }
    });
    const _interop_require_default = _interop_require_default$1;
    const _react = /*#__PURE__*/_interop_require_default._(React__default);
    const HeadManagerContext = _react.default.createContext({});
    if (process.env.NODE_ENV !== "production") {
      HeadManagerContext.displayName = "HeadManagerContext";
    }
  })(headManagerContext);
  return headManagerContext;
}
var ampMode = {};
var hasRequiredAmpMode;
function requireAmpMode() {
  if (hasRequiredAmpMode) return ampMode;
  hasRequiredAmpMode = 1;
  (function (exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    Object.defineProperty(exports, "isInAmpMode", {
      enumerable: true,
      get: function () {
        return isInAmpMode;
      }
    });
    function isInAmpMode(param) {
      let {
        ampFirst = false,
        hybrid = false,
        hasQuery = false
      } = param === void 0 ? {} : param;
      return ampFirst || hybrid && hasQuery;
    }
  })(ampMode);
  return ampMode;
}
var warnOnce = {};
var hasRequiredWarnOnce;
function requireWarnOnce() {
  if (hasRequiredWarnOnce) return warnOnce;
  hasRequiredWarnOnce = 1;
  (function (exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    Object.defineProperty(exports, "warnOnce", {
      enumerable: true,
      get: function () {
        return warnOnce;
      }
    });
    let warnOnce = _ => {};
    if (process.env.NODE_ENV !== "production") {
      const warnings = new Set();
      warnOnce = msg => {
        if (!warnings.has(msg)) {
          console.warn(msg);
        }
        warnings.add(msg);
      };
    }
  })(warnOnce);
  return warnOnce;
}
(function (module, exports) {
  "use client";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  function _export(target, all) {
    for (var name in all) Object.defineProperty(target, name, {
      enumerable: true,
      get: all[name]
    });
  }
  _export(exports, {
    defaultHead: function () {
      return defaultHead;
    },
    default: function () {
      return _default;
    }
  });
  const _interop_require_default = _interop_require_default$1;
  const _interop_require_wildcard = _interop_require_wildcard$1;
  const _react = /*#__PURE__*/_interop_require_wildcard._(React__default);
  const _sideeffect = /*#__PURE__*/_interop_require_default._(requireSideEffect());
  const _ampcontext = requireAmpContext();
  const _headmanagercontext = requireHeadManagerContext();
  const _ampmode = requireAmpMode();
  const _warnonce = requireWarnOnce();
  function defaultHead(inAmpMode) {
    if (inAmpMode === void 0) inAmpMode = false;
    const head = [/*#__PURE__*/_react.default.createElement("meta", {
      charSet: "utf-8"
    })];
    if (!inAmpMode) {
      head.push( /*#__PURE__*/_react.default.createElement("meta", {
        name: "viewport",
        content: "width=device-width"
      }));
    }
    return head;
  }
  function onlyReactElement(list, child) {
    // React children can be "string" or "number" in this case we ignore them for backwards compat
    if (typeof child === "string" || typeof child === "number") {
      return list;
    }
    // Adds support for React.Fragment
    if (child.type === _react.default.Fragment) {
      return list.concat(
      // @ts-expect-error @types/react does not remove fragments but this could also return ReactPortal[]
      _react.default.Children.toArray(child.props.children).reduce(
      // @ts-expect-error @types/react does not remove fragments but this could also return ReactPortal[]
      (fragmentList, fragmentChild) => {
        if (typeof fragmentChild === "string" || typeof fragmentChild === "number") {
          return fragmentList;
        }
        return fragmentList.concat(fragmentChild);
      }, []));
    }
    return list.concat(child);
  }
  const METATYPES = ["name", "httpEquiv", "charSet", "itemProp"];
  /*
   returns a function for filtering head child elements
   which shouldn't be duplicated, like <title/>
   Also adds support for deduplicated `key` properties
  */
  function unique() {
    const keys = new Set();
    const tags = new Set();
    const metaTypes = new Set();
    const metaCategories = {};
    return h => {
      let isUnique = true;
      let hasKey = false;
      if (h.key && typeof h.key !== "number" && h.key.indexOf("$") > 0) {
        hasKey = true;
        const key = h.key.slice(h.key.indexOf("$") + 1);
        if (keys.has(key)) {
          isUnique = false;
        } else {
          keys.add(key);
        }
      }
      // eslint-disable-next-line default-case
      switch (h.type) {
        case "title":
        case "base":
          if (tags.has(h.type)) {
            isUnique = false;
          } else {
            tags.add(h.type);
          }
          break;
        case "meta":
          for (let i = 0, len = METATYPES.length; i < len; i++) {
            const metatype = METATYPES[i];
            if (!h.props.hasOwnProperty(metatype)) continue;
            if (metatype === "charSet") {
              if (metaTypes.has(metatype)) {
                isUnique = false;
              } else {
                metaTypes.add(metatype);
              }
            } else {
              const category = h.props[metatype];
              const categories = metaCategories[metatype] || new Set();
              if ((metatype !== "name" || !hasKey) && categories.has(category)) {
                isUnique = false;
              } else {
                categories.add(category);
                metaCategories[metatype] = categories;
              }
            }
          }
          break;
      }
      return isUnique;
    };
  }
  /**
   *
   * @param headChildrenElements List of children of <Head>
   */
  function reduceComponents(headChildrenElements, props) {
    const {
      inAmpMode
    } = props;
    return headChildrenElements.reduce(onlyReactElement, []).reverse().concat(defaultHead(inAmpMode).reverse()).filter(unique()).reverse().map((c, i) => {
      const key = c.key || i;
      if (process.env.NODE_ENV !== "development" && process.env.__NEXT_OPTIMIZE_FONTS && !inAmpMode) {
        if (c.type === "link" && c.props["href"] &&
        // TODO(prateekbh@): Replace this with const from `constants` when the tree shaking works.
        ["https://fonts.googleapis.com/css", "https://use.typekit.net/"].some(url => c.props["href"].startsWith(url))) {
          const newProps = {
            ...(c.props || {})
          };
          newProps["data-href"] = newProps["href"];
          newProps["href"] = undefined;
          // Add this attribute to make it easy to identify optimized tags
          newProps["data-optimized-fonts"] = true;
          return /*#__PURE__*/_react.default.cloneElement(c, newProps);
        }
      }
      if (process.env.NODE_ENV === "development") {
        // omit JSON-LD structured data snippets from the warning
        if (c.type === "script" && c.props["type"] !== "application/ld+json") {
          const srcMessage = c.props["src"] ? '<script> tag with src="' + c.props["src"] + '"' : "inline <script>";
          (0, _warnonce.warnOnce)("Do not add <script> tags using next/head (see " + srcMessage + "). Use next/script instead. \nSee more info here: https://nextjs.org/docs/messages/no-script-tags-in-head-component");
        } else if (c.type === "link" && c.props["rel"] === "stylesheet") {
          (0, _warnonce.warnOnce)('Do not add stylesheets using next/head (see <link rel="stylesheet"> tag with href="' + c.props["href"] + '"). Use Document instead. \nSee more info here: https://nextjs.org/docs/messages/no-stylesheets-in-head-component');
        }
      }
      return /*#__PURE__*/_react.default.cloneElement(c, {
        key
      });
    });
  }
  /**
   * This component injects elements to `<head>` of your page.
   * To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
   */
  function Head(param) {
    let {
      children
    } = param;
    const ampState = (0, _react.useContext)(_ampcontext.AmpStateContext);
    const headManager = (0, _react.useContext)(_headmanagercontext.HeadManagerContext);
    return /*#__PURE__*/_react.default.createElement(_sideeffect.default, {
      reduceComponentsToState: reduceComponents,
      headManager: headManager,
      inAmpMode: (0, _ampmode.isInAmpMode)(ampState)
    }, children);
  }
  const _default = Head;
  if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
    Object.defineProperty(exports.default, '__esModule', {
      value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
  }
})(head$1, head$1.exports);
var headExports = head$1.exports;
var head = headExports;
var Head = /*@__PURE__*/getDefaultExportFromCjs(head);
var observerMap = new Map();
var RootIds = new WeakMap();
var rootId = 0;
var unsupportedValue = undefined;
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */

function optionsToId(options) {
  return Object.keys(options).sort().filter(function (key) {
    return options[key] !== undefined;
  }).map(function (key) {
    return key + "_" + (key === 'root' ? getRootId(options.root) : options[key]);
  }).toString();
}
function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  var id = optionsToId(options);
  var instance = observerMap.get(id);
  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    var elements = new Map();
    var thresholds;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        var inView = entry.isIntersecting && thresholds.some(function (threshold) {
          return entry.intersectionRatio >= threshold;
        }); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }
        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(function (callback) {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id,
      observer: observer,
      elements: elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */

function observe(element, callback, options, fallbackInView) {
  if (options === void 0) {
    options = {};
  }
  if (fallbackInView === void 0) {
    fallbackInView = unsupportedValue;
  }
  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    var bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return function () {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact

  var _createObserver = createObserver(options),
    id = _createObserver.id,
    observer = _createObserver.observer,
    elements = _createObserver.elements; // Register the callback listener for this element

  var callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements["delete"](element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap["delete"](id);
    }
  };
}

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    threshold = _ref.threshold,
    delay = _ref.delay,
    trackVisibility = _ref.trackVisibility,
    rootMargin = _ref.rootMargin,
    root = _ref.root,
    triggerOnce = _ref.triggerOnce,
    skip = _ref.skip,
    initialInView = _ref.initialInView,
    fallbackInView = _ref.fallbackInView;
  var unobserve = React.useRef();
  var _React$useState = React.useState({
      inView: !!initialInView
    }),
    state = _React$useState[0],
    setState = _React$useState[1];
  var setRef = React.useCallback(function (node) {
    if (unobserve.current !== undefined) {
      unobserve.current();
      unobserve.current = undefined;
    } // Skip creating the observer

    if (skip) return;
    if (node) {
      unobserve.current = observe(node, function (inView, entry) {
        setState({
          inView: inView,
          entry: entry
        });
        if (entry.isIntersecting && triggerOnce && unobserve.current) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve.current();
          unobserve.current = undefined;
        }
      }, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold,
        // @ts-ignore
        trackVisibility: trackVisibility,
        // @ts-ignore
        delay: delay
      }, fallbackInView);
    }
  },
  // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [
  // If the threshold is an array, convert it to a string so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  /* eslint-disable-next-line */

  useEffect(function () {
    if (!unobserve.current && state.entry && !triggerOnce && !skip) {
      // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView
      });
    }
  });
  var result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}
var layoutOptions = Object.freeze({
  ONE_COLUMN_NARROW: '1 Column - Narrow',
  ONE_COLUMN_MID: '1 Column - Mid',
  ONE_COLUMN_WIDE: '1 Column - Wide',
  TWO_COLUMNS_WIDE_SPLIT: '2 Columns - Wide Split',
  TWO_COLUMNS_RIGHT_FEATURE: '2 Columns - Right Feature',
  TWO_COLUMNS_LEFT_FEATURE: '2 Columns - Left Feature',
  TWO_COLUMNS_NARROW_SPLIT: '2 Columns - Narrow Split',
  THREE_COLUMNS: '3 Columns',
  FOUR_COLUMNS_WIDE: '4 Columns - Wide'
});
({
  'One Column': 'oneColumn',
  // deprecated
  'Two Column': 'twoColumn',
  // deprecated
  'Three Column': 'threeColumn',
  // deprecated
  [layoutOptions.ONE_COLUMN_WIDE]: 'oneColumn',
  [layoutOptions.ONE_COLUMN_MID]: 'oneColumnMid',
  [layoutOptions.ONE_COLUMN_NARROW]: 'oneColumnNarrow',
  [layoutOptions.TWO_COLUMNS_WIDE_SPLIT]: 'twoColumn',
  [layoutOptions.TWO_COLUMNS_RIGHT_FEATURE]: 'twoColumnRight',
  [layoutOptions.TWO_COLUMNS_LEFT_FEATURE]: 'twoColumnLeft',
  [layoutOptions.TWO_COLUMNS_NARROW_SPLIT]: 'twoColumnNarrowSplit',
  [layoutOptions.THREE_COLUMNS]: 'threeColumn',
  [layoutOptions.FOUR_COLUMNS_WIDE]: 'fourColumn'
});
({
  /** Alignment for the content within the grid. */
  align: PropTypes.oneOf(['left', 'center']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  /** Optional <Heading /> to be rendered above the grid container. */
  heading: PropTypes.node,
  /** Layout options for how content is distributed across columns. */
  layout: PropTypes.oneOf(['1 Column - Wide', '1 Column - Mid', '1 Column - Narrow', '2 Columns - Wide Split', '2 Columns - Right Feature', '2 Columns - Left Feature', '2 Columns - Narrow Split', '3 Columns', '4 Columns - Wide']),
  /** Control whether the children will be rendered as an unordered list. */
  renderAsList: PropTypes.bool
});
var GridContainerContext = /*#__PURE__*/React__default.createContext();
var styles$1 = {
  "blockImageContainer": "blockImageContainer-1qor8",
  "lazyImageContainer": "lazyImageContainer-1qor8",
  "picture": "picture-1qor8",
  "pictureContainer": "pictureContainer-1qor8",
  "blockImg": "blockImg-1qor8"
};
var _excluded$2 = ["alt", "block", "className", "containerClassName", "fileFormat", "lazy", "maxWidth", "mobileSrc", "prefix", "preload", "sizes", "src", "tag"];

// Returns a sizes attribute for an <img />
// breakpoints is an array of objects with a breakpoint property and a slotSize property
// ex:
// [{ breakpoint: "1372px", slotSize: "312px" },
// { breakpoint: "981px", slotSize: "23vw" },
// { breakpoint: "641px", slotSize: "31vw" },
// { slotSize: "46vw" }]
// Note that these are in descending order of (min-width) and order does matter
// The final member of breakpoints should be the default slot size for the img

// Disabling this es-lint rule because alt text is being passed in by
// spreading in props but es-lint isn't recognizing it (line 192)

var prefixRegex = /(\?\$(.*?)\$)$/im;

/**
 * @param {string} baseImageUrl
 * @return {boolean}
 */
var hasExistingPrefix = baseImageUrl => {
  if (!baseImageUrl) return false;
  return prefixRegex.test(baseImageUrl);
};
var DEFAULT_SRC_WIDTH = 1280;
var FORMAT = Object.freeze({
  JPEG: 'jpeg',
  WEBP: 'webp'
});

/**
 * @param {string} baseImageUrl
 * @param {number} width
 * @return {string}
 */
var getDefaultSrcPresets = _ref => {
  var {
    baseImageUrl,
    width,
    prefix
  } = _ref;
  return hasExistingPrefix(baseImageUrl) ? baseImageUrl : "".concat(baseImageUrl, "?").concat(prefix ? "$".concat(prefix, "$&") : '', "wid=").concat(width || DEFAULT_SRC_WIDTH, "&op_usm=0.5,2,10,0&fmt=").concat(FORMAT.JPEG, "&qlt=75,1&fit=constrain,0&op_sharpen=0&resMode=sharp2&iccEmbed=0&printRes=72");
};
var needsLegacyImgSupport = () => {
  if (typeof navigator === 'undefined' || !navigator.userAgent) return false;
  return navigator.userAgent.match(/Trident/); // IE-only
};
var scene7APISrcSet = _ref2 => {
  var {
    baseImageUrl,
    prefix,
    maxWidth,
    format
  } = _ref2;
  // common query params for all sizes
  // see https://lululemon.atlassian.net/wiki/spaces/CET/pages/827458212/Scene7+Image+Presets+for+PDP+webpages
  var baseScene7QueryParams = "fmt=".concat(format || FORMAT.JPEG, "&qlt=").concat(format === FORMAT.WEBP ? '80' : '75', ",1&fit=constrain,0&op_sharpen=0&resMode=sharp2&iccEmbed=0&printRes=72");

  // Image sharpening config for Scene7's unsharp mask (op_usm query parameter)
  // Comma-separated list made of values for amount, radius, threshold, and monochrome
  // Actual values come from https://lululemon.atlassian.net/wiki/spaces/CET/pages/858522766/USM+Setting+Optimization+for+PDP+Images
  //
  // best practices: https://marketing.adobe.com/resources/help/en_US/s7/sharpening/s7_sharpening_images.pdf
  // docs: https://docs.adobe.com/content/help/en/dynamic-media-classic/using/master-files/best-practices-optimizing-quality-images.html
  var unsharpMask1x = '0.8,1,10,0';
  var unsharpMask2x = '0.5,2,10,0';

  // determined after some research. some sources:
  // https://gs.statcounter.com/screen-resolution-stats/all/united-states-of-america
  // https://deviceatlas.com/blog/most-used-smartphone-screen-resolutions#us
  // https://developer.apple.com/library/archive/documentation/DeviceInformation/Reference/iOSDeviceCompatibility/Displays/Displays.html
  // https://medium.com/hceverything/applying-srcset-choosing-the-right-sizes-for-responsive-images-at-different-breakpoints-a0433450a4a3
  // akamai
  // this list can be edited or extended safely
  var scene7ImageWidths = [{
    width: 320,
    usm: unsharpMask1x
  },
  // small image on desktops or slow connections
  {
    width: 750,
    usm: unsharpMask1x
  },
  // phones 2x (iPhone 6,7,8)
  {
    width: 1080,
    usm: unsharpMask2x
  },
  // phones 2.6x (iPhone 6,7,8 Plus)
  {
    width: 1125,
    usm: unsharpMask2x
  },
  // phones 3x (iPhone X)
  {
    width: 1280,
    usm: unsharpMask2x
  },
  // desktops 1x, iPhone 3x, phones 3x
  {
    width: 1440,
    usm: unsharpMask2x
  },
  // desktops 1x, phones 3x
  {
    width: 1600,
    usm: unsharpMask2x
  },
  // desktops 1x, iPad 2x, phones 4x
  {
    width: 2420,
    usm: unsharpMask2x
  },
  // desktops 2x
  {
    width: 2644,
    usm: unsharpMask2x
  } // 2x grid max
  ];
  var constructSrcSetString = imageWidths => {
    return imageWidths.map(_ref3 => {
      var {
        width,
        usm
      } = _ref3;
      return "".concat(baseImageUrl, "?").concat(prefix ? "$".concat(prefix, "$&") : '', "wid=").concat(width, "&op_usm=").concat(usm, "&").concat(baseScene7QueryParams, " ").concat(width, "w");
    }).join(',\n');
  };

  // Optional maxWidth parameter.
  // Filters out imageWidths larger than this param and includes it in the list of image widths
  if (maxWidth) {
    var scene7ImageWidthsWithMaxWidth = [...scene7ImageWidths.filter(_ref4 => {
      var {
        width
      } = _ref4;
      return width < maxWidth;
    }), {
      width: maxWidth,
      usm: unsharpMask1x
    }];
    return constructSrcSetString(scene7ImageWidthsWithMaxWidth);
  }

  // most important detail: the `wid` image url param and the srcset `w` width are exactly the same
  return constructSrcSetString(scene7ImageWidths);
};
var Image = /*#__PURE__*/React__default.forwardRef((_ref5, ref
// eslint-disable-next-line sonarjs/cognitive-complexity
) => {
  var {
      alt,
      block,
      className,
      containerClassName,
      fileFormat,
      lazy,
      maxWidth: maxWidthProp,
      mobileSrc,
      prefix,
      preload,
      sizes: sizesProp,
      src,
      tag: Tag
    } = _ref5,
    rest = _objectWithoutProperties$1(_ref5, _excluded$2);
  var [lazyLoadRef, inView] = useInView({
    triggerOnce: true,
    rootMargin: '300px'
  });
  var [imgFallback, setImgFallback] = useState('data:,');
  var imageSizesForGridLayout = useContext(GridContainerContext);
  var sizes = sizesProp || (imageSizesForGridLayout === null || imageSizesForGridLayout === void 0 ? void 0 : imageSizesForGridLayout.sizes);
  var maxWidth = maxWidthProp || (imageSizesForGridLayout === null || imageSizesForGridLayout === void 0 ? void 0 : imageSizesForGridLayout.maxWidth);
  useEffect(() => {
    if (needsLegacyImgSupport() || hasExistingPrefix(src)) {
      setImgFallback(getDefaultSrcPresets({
        baseImageUrl: src,
        width: maxWidth < DEFAULT_SRC_WIDTH ? maxWidth : DEFAULT_SRC_WIDTH
      }));
    }
  }, [src, maxWidth]);
  var constructSrcSet = (format, src, mobileSrc) => {
    var urlSrc = mobileSrc || src;
    return hasExistingPrefix(src) ? undefined : scene7APISrcSet({
      baseImageUrl: urlSrc,
      format: format,
      maxWidth,
      prefix
    });
  };
  var imageProps = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return _objectSpread2$1(_objectSpread2$1({}, rest), {}, {
      sizes,
      srcSet: constructSrcSet(fileFormat, src),
      loading,
      src: imgFallback,
      alt
    });
  };
  var containerClasses = cs(styles$1.lazyImageContainer, containerClassName, {
    // Chrome has a bug where intersection observer isn't working consistently
    // with inline elements, this forces the span to be block level if out of view
    [styles$1.blockImageContainer]: !inView && Tag === 'span'
  });
  var fileFormats = fileFormat ? [fileFormat] : [FORMAT.WEBP, FORMAT.JPEG];
  var sources = fileFormats.map((format, index) => /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: format
  }, /*#__PURE__*/React__default.createElement("source", {
    sizes: sizes,
    media: mobileSrc && '(min-width: 500px)',
    srcSet: constructSrcSet(format, src),
    type: "image/".concat(format),
    "data-testid": "source-".concat(index)
  }), mobileSrc && /*#__PURE__*/React__default.createElement("source", {
    sizes: sizes,
    media: !sizes ? '(min-width: 0px)' : null,
    srcSet: constructSrcSet(format, src, mobileSrc),
    type: "image/".concat(format),
    "data-testid": "source-".concat(index, "-sm")
  })));
  var preloadImgLink = /*#__PURE__*/React__default.createElement("link", {
    as: "image",
    "data-testid": "preload-img-link",
    imageSizes: sizes,
    imageSrcSet: constructSrcSet('webp', src),
    rel: "preload",
    type: "image/webp"
  });
  return lazy ? /*#__PURE__*/React__default.createElement(Tag, {
    className: containerClasses,
    ref: lazyLoadRef,
    "data-testid": "image"
  }, preload && /*#__PURE__*/React__default.createElement(Head, null, preloadImgLink), inView && /*#__PURE__*/React__default.createElement("picture", null, sources, /*#__PURE__*/React__default.createElement("img", _extends$1({}, imageProps('lazy'), {
    className: cs({
      [styles$1.blockImg]: !!block,
      [className]: !!className
    }),
    "data-testid": "lazy-image",
    ref: ref
  })))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, preload && /*#__PURE__*/React__default.createElement(Head, null, preloadImgLink), /*#__PURE__*/React__default.createElement("picture", {
    className: cs(styles$1.pictureContainer)
  }, sources, /*#__PURE__*/React__default.createElement("img", _extends$1({}, imageProps(), {
    className: cs({
      [styles$1.blockImg]: !!block,
      [className]: !!className
    }),
    "data-testid": "not-lazy-image",
    ref: ref
  }))));
});
var propTypes$2 = {
  /** Decorative images should use an empty alt value so they are ignored by screen readers. */
  alt: PropTypes.string,
  /** Whether to treat the image as block-level and fill its container. */
  block: PropTypes.bool,
  /** Optional classname to add to the image element. */
  className: PropTypes.string,
  /** Optional classname to add to the lazy loaded image wrapper. */
  containerClassName: PropTypes.string,
  /** Optional image file format: webp | jpeg | png-alpha */
  fileFormat: PropTypes.string,
  /** Whether to lazyload the image using intersection observer. */
  lazy: PropTypes.bool,
  /** Maximum width of the image asset - any slot sizes greater than this will be omitted from the srcset. */
  maxWidth: PropTypes.number,
  /** Optional prefix to add in the image URL, for searchability. */
  prefix: PropTypes.string,
  /** Optional flag that allows responsive images to preload by adding  preload resource to Next.js Head */
  preload: PropTypes.bool,
  /** Comma-separated list of media conditions and slot sizes for sizes attribute. Can be generated using the constructSizes() util. */
  sizes: PropTypes.string,
  /** Image URL to be used as the base to generate responsive images from. Also used as fallback image for older browsers. */
  src: PropTypes.string.isRequired,
  /** Image URL for mobile viewpoints */
  mobileSrc: PropTypes.string,
  /** HTML element tag to use for the image wrapper. */
  tag: PropTypes.string
};
var defaultProps$2 = {
  alt: '',
  block: false,
  className: '',
  containerClassName: '',
  fileFormat: null,
  lazy: true,
  maxWidth: null,
  mobileSrc: null,
  prefix: '',
  preload: false,
  sizes: null,
  tag: 'span'
};
Image.propTypes = propTypes$2;
Image.defaultProps = defaultProps$2;

var styles = {"icon":"icon-3hx2f","ctaBlock":"ctaBlock-3hx2f","fixedHeight":"fixedHeight-3hx2f","content":"content-3hx2f","heading":"heading-3hx2f","subContent":"subContent-3hx2f","imageWrapper":"imageWrapper-3hx2f","image":"image-3hx2f","contentWrapper":"contentWrapper-3hx2f"};

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var DEFAULT_LINK_TYPE = 'a';
var LinkProviderContext = /*#__PURE__*/React__default.createContext(DEFAULT_LINK_TYPE);
({
  /** The component/element pattern library components (and LinkGenerator) should use for links */
  component: PropTypes.elementType.isRequired
});
var LinkGenerator = /*#__PURE__*/React__default.forwardRef((props, ref) => {
  var Link = useContext(LinkProviderContext) || DEFAULT_LINK_TYPE;
  return /*#__PURE__*/React__default.createElement(Link, _extends({
    ref: ref
  }, props));
});

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }
  return getRandomValues(rnds8);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];
for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}
function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = {
  randomUUID
};

function v4(options, buf, offset) {
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }
  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;
    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }
    return buf;
  }
  return unsafeStringify(rnds);
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var _excluded$1 = ["className", "content", "title", "role", "aria-labelledby", "aria-hidden"];

// Custom hook to grab a default iconId using React.useId()
// NOTE: useId is only available in React 18+
var useDefaultIconId = () => {
  var reactId = useId === null || useId === void 0 ? void 0 : useId();
  if (reactId) return "icon_".concat(reactId);
  return undefined;
};
var Icon = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      className,
      content,
      title,
      role,
      'aria-labelledby': ariaLabelledby,
      'aria-hidden': ariaHidden
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded$1);
  var [iconId, setIconId] = useState(useDefaultIconId());
  useEffect(() => {
    // If using React < 18, use UUID to render the unique iconId
    // UUID v4 causes hydration issues in SSR because it consumes crypto.
    //    Crypto is a built in node.js package and is not consumed properly in Next.js
    //    So UUID value needs to be set from useEffect which renders client side.
    if (!iconId) {
      setIconId("icon_".concat(v4()));
    }
  }, [iconId]);
  var {
    'aria-label': ariaLabel,
    'aria-describedby': ariaDescribedby
  } = otherProps;
  var hasLabel = !!title || !!ariaLabelledby || !!ariaLabel || !!ariaDescribedby;
  return useMemo(() => {
    var _content$props;
    return /*#__PURE__*/React__default.cloneElement(content, _objectSpread2({
      children: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, title ? /*#__PURE__*/React__default.createElement("title", {
        id: iconId
      }, title) : null, content === null || content === void 0 ? void 0 : (_content$props = content.props) === null || _content$props === void 0 ? void 0 : _content$props.children),
      className,
      ref,
      focusable: false,
      role,
      'aria-labelledby': ariaLabelledby || (title ? iconId : undefined),
      'aria-hidden': typeof ariaHidden !== 'undefined' ? ariaHidden : !hasLabel
    }, otherProps));
  }, [content, className, title, role, hasLabel, ref, ariaLabelledby, ariaHidden, otherProps, iconId]);
});
var propTypes$1 = {
  /** Node for the individual icon import */
  content: PropTypes.node.isRequired,
  /** Optional class to be applied to the SVG element */
  className: PropTypes.string,
  /** Value for the <title> element describing the icon */
  title: PropTypes.string,
  role: PropTypes.string,
  /** By default points to the <title> element, if provided. */
  'aria-labelledby': PropTypes.string,
  /** By default is set to 'true' if no title or label is provided. */
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};
var defaultProps$1 = {
  className: null,
  title: '',
  role: 'img',
  'aria-labelledby': undefined,
  'aria-hidden': undefined
};
Icon.propTypes = propTypes$1;
Icon.defaultProps = defaultProps$1;

var _excluded = ["heading", "subContent", "className", "href", "tag", "imageProps"];
var CTABlock = _ref => {
  var {
      heading,
      subContent,
      className,
      href,
      tag,
      imageProps
    } = _ref,
    otherProps = _objectWithoutProperties$2(_ref, _excluded);
  var Tag = tag;
  var hasImage = !!(imageProps !== null && imageProps !== void 0 && imageProps.src);
  return /*#__PURE__*/React__default.createElement(Tag, _extends$2({
    href: href,
    className: cs(styles.ctaBlock, className, {
      [styles.fixedHeight]: hasImage
    })
  }, otherProps), hasImage && /*#__PURE__*/React__default.createElement("div", {
    className: styles.imageWrapper
  }, /*#__PURE__*/React__default.createElement(Image, _extends$2({
    className: styles.image
  }, imageProps))), /*#__PURE__*/React__default.createElement("div", {
    className: styles.contentWrapper
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.content
  }, !!heading && /*#__PURE__*/React__default.createElement("span", {
    className: styles.heading
  }, heading), !!subContent && /*#__PURE__*/React__default.createElement("span", {
    className: styles.subContent
  }, subContent)), /*#__PURE__*/React__default.createElement(Icon, {
    className: styles.icon,
    content: rightLinkArrowIcon
  })));
};
var propTypes = {
  imageProps: PropTypes.shape(_objectSpread2$2(_objectSpread2$2({}, propTypes$2), {}, {
    src: PropTypes.string
  })),
  heading: PropTypes.node,
  subContent: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.elementType])
};
var defaultProps = {
  heading: null,
  subContent: null,
  className: '',
  href: '',
  tag: LinkGenerator,
  imageProps: null
};
CTABlock.propTypes = propTypes;
CTABlock.defaultProps = defaultProps;

export { CTABlock, defaultProps, propTypes };
//# sourceMappingURL=index.js.map
